import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserRedemptionUniqueCode } from '@/shared/model/user-redemption-unique-code.model';

const baseApiUrl = 'api/user-redemption-unique-codes';
const baseSearchApiUrl = 'api/_search/user-redemption-unique-codes?query=';

export default class UserRedemptionUniqueCodeService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserRedemptionUniqueCode> {
    return new Promise<IUserRedemptionUniqueCode>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserRedemptionUniqueCode): Promise<IUserRedemptionUniqueCode> {
    return new Promise<IUserRedemptionUniqueCode>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserRedemptionUniqueCode): Promise<IUserRedemptionUniqueCode> {
    return new Promise<IUserRedemptionUniqueCode>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
